import { errorMsg } from '../../constants/messages';

const ServiceStepsFormData = [
  {
    title: 'Service Step',
    name: 'service',
    label: 'Service',
    fieldType: {
      name: 'select',
      options: [],
    },
    placeholder: 'Click here to select a Service',
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Service',
      enableSort: false,
      allowAddRecordClick: true,
      columnType: 'displayName',
    },
    isTableHeader: true,
    isAccordian: true,
    readonly: false,
  },
  {
    name: 'description',
    label: 'Description',
    fieldType: {
      name: 'textarea',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Description', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'sequence',
    label: 'Sequence',
    fieldType: {
      name: 'number',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Sequence', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'processes',
    label: 'Process Details',
    fieldType: {
      name: 'serviceProcess',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Process Details', columnType: 'clickHere', allowAddRecordClick: true },
    isTableHeader: false,
    isAccordian: true,
    default: '',
  },
];

export { ServiceStepsFormData };
export default ServiceStepsFormData;
